<div [ngClass]="{ 'bm--bg-popup  bm--bg-popup__transparent': isDropdownOpen }" (click)="toggleDropdown($event)"></div>

<div class="mob-controls">
  <div class="mob-controls__dots" (click)="toggleDropdown($event)">
    <div class="btv-icon-dots theme-beats__dotsIcon"></div>
  </div>

  @if (isDropdownOpen) {
    <div class="mob-controls__content theme-beats__dropdownControlsBg">
      <div class="bm--dropdown-triangle theme-beats__dropdownControlsBg"></div>
      <!-- Download btn -->
      @if (track.demoDownloading && showDownloadBtn) {
        <div class="mob-controls__download" (click)="$event.stopPropagation()">
          <bmcore-download-btn
            [demoDownloading]="track.demoDownloading"
            [downloadMp3Url]="track.mp3"
            [parentComponent]="'track-mob-controls'"
            [trackId]="track.id"
          >
          </bmcore-download-btn>
        </div>
      }
      <!-- Favorite btn -->
      @if (isShowFavBtn) {
        <div class="mob-controls__fav" (click)="$event.stopPropagation()">
          <bmcore-fav-btn [track]="track" [dropdownMode]="true"></bmcore-fav-btn>
        </div>
      }
      <!-- Share btn -->
      @if (showShareBtn) {
        <bmcore-share-btn [track]="track" [parentComponent]="'track-mob-controls'"></bmcore-share-btn>
      }
    </div>
  }
</div>
